<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true">+增加章节</Button>
          </Col>
          <Col span="5">
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="chapterName" label="章节名称" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <a @click="modal2=true;chapterId=scope.row.id;chapterName=scope.row.chapterName">{{scope.row.chapterName}}</a>
          </template>
        </el-table-column>
        <!--<el-table-column prop="productId" label="节点数量" :show-tooltip-when-overflow="true"></el-table-column>-->

        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save">
      <Form :label-width="80">
				<FormItem label="章节名称">
					<Input v-model="detail.chapterName"/>
				</FormItem>
      </Form>
    </Modal>

    <Modal :title="chapterName+'（节点视频上传）'"  width="60%" v-model="modal2">
      <ProductItem :chapterId="chapterId"></ProductItem>
    </Modal>

  </div>
</template>

<script>

  import ProductItem from './ProductItem'
  export default {
    components:{ProductItem},
    props:['productId'],
    data(){
      return{
        baseUrl:'/api/productonline/chapter/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
        chapterId:0,
        chapterName:'',
        modal2:false
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        params.push('t.productId@=@'+this.productId);
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        this.detail.productId = this.productId;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    },
    watch: {
      productId: {
        handler(newValue, oldValue) {
          this.load();
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/product/online/Chapter.vue